<template>
  <div class="flex min-h-screen bg-primaryBg font-inter">
    <aside class="hidden md:block w-[294px] flex-shrink-0 bg-primaryBg text-primaryDark">
      <Sidebar />
    </aside>

    <div class="flex-grow">
      <main class="w-full">
        <AchievementsComponent />
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/SidebarComponent.vue';
import AchievementsComponent from '@/components/achievements/AchievementsComponent.vue';

export default {
  name: 'AchievementsView',
  components: {
    Sidebar,
    AchievementsComponent,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
</style>
